/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetResearchSettingsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createOkFromDiscriminatorValue, serializeOk, serializeUpdateResearchSettingsRequest, type ErrorResponse, type GetResearchSettingsResponse, type InternalErrorResponse, type Ok, type UpdateResearchSettingsRequest } from '../../../models/index.js';
// @ts-ignore
import { SuggestRequestBuilderRequestsMetadata, type SuggestRequestBuilder } from './suggest/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/research-settings
 */
export interface ResearchSettingsRequestBuilder extends BaseRequestBuilder<ResearchSettingsRequestBuilder> {
    /**
     * The suggest property
     */
    get suggest(): SuggestRequestBuilder;
    /**
     * Returns the organization's AI access-request research settings (industry description and B2B approval criteria).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetResearchSettingsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<GetResearchSettingsResponse | undefined>;
    /**
     * Sets the organization's AI access-request research settings (industry description and B2B approval criteria). Empty values clear a setting.
     * @param body Updates the organization's AI access-request research settings. Both fields are optional freetext; sending null or an empty value clears the corresponding setting (research then falls backto graceful defaults).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<Ok>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     put(body: UpdateResearchSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<Ok | undefined>;
    /**
     * Returns the organization's AI access-request research settings (industry description and B2B approval criteria).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
    /**
     * Sets the organization's AI access-request research settings (industry description and B2B approval criteria). Empty values clear a setting.
     * @param body Updates the organization's AI access-request research settings. Both fields are optional freetext; sending null or an empty value clears the corresponding setting (research then falls backto graceful defaults).
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPutRequestInformation(body: UpdateResearchSettingsRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const ResearchSettingsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/research-settings";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ResearchSettingsRequestBuilderNavigationMetadata: Record<Exclude<keyof ResearchSettingsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    suggest: {
        requestsMetadata: SuggestRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ResearchSettingsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ResearchSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetResearchSettingsResponseFromDiscriminatorValue,
    },
    put: {
        uriTemplate: ResearchSettingsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createOkFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeUpdateResearchSettingsRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
